module.exports = __webpack_public_path__ + "img/ico_kjzx.446a0164.png";